export const errorMessages: { [key: string]: string } = {
  requiredField: 'Kötelező mező',
  invalidFormat: 'Nem megfelelő formátum',
  securePw:
    'Jelszónak legalább 8 karakter hosszúnak kell lennie és tartalmaznia kell: 1 nagy, 1 kis betűt és 1 számot',
  notMatchingPasswords: 'Jelszavak nem egyeznek',
  privacyPolicyRequired: 'Az adatkezelési nyilatkozat elfogadása kötelező!'
}
